import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class UploadAdditionalDocumentsService {

  constructor(private http: HttpClient) { }

  public getDasComments(appId):Observable<any>{
    return this.http.get(environment.BASE_URL_HRD_PUCA+'puca/getCommentsList/'+appId)
  }

  public submitAdditionalDocument(appId,profileId):Observable<any>{
    return this.http.get(environment.BASE_URL_PUCA+'das/updateDetailsOnUploadDocuments/'+appId+'/'+profileId)
  }

  public getDasFormDetails(): Observable<any>{
    return this.http.get(environment.BASE_URL_PUCA+'das/getInitFormData')
  }

  public getDocumentList(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'attachment/getDocumentByAppIdAndAcronym',payload)
  }

  public deleteDocument(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'attachment/deleteByDocumentId',payload)
  }

  public getAttachmentByDocumentId(payload){
    return this.http.post(environment.BASE_URL_COMMON+'attachment/getAttachmentByDocumentId',payload)
  }
}
